<div class="row">
  <div class="col-12">
    <h4>{{this.label}}</h4>
  </div>
  <div class="col-12" style="overflow-y: scroll; overflow-x: hidden; margin-right: 0px; padding-left: 16px;" [ngStyle]="{'max-height': this.readOnly ? 'calc(100vh - 198px)' : 'calc(100vh - 275px)'}">
    <ng-content></ng-content>
  </div>

  @if (!this.readOnly) {
  <div class="col-12" style="padding-top: 8px; border-top: 1px solid lightgray;">
    <button type="button" class="btn btn-outline-primary" (click)="this.onPreviousClick()" [disabled]="this.firstSection">Previous</button>&nbsp;
    <button type="button" class="btn btn-outline-primary" (click)="this.onNextClick()" [disabled]="!this.isValid() || this.lastSection">Next</button>&nbsp;
    <button type="button" class="btn btn-primary" (click)="this.onSaveClick()" [disabled]="!this.parentIsValid()" [ngClass]="{ 'invisible': !this.parentIsValid()}">Submit</button>
  </div>
  }
</div>
